import { createDraftSafeSelector } from "@reduxjs/toolkit"
import { GET_AVAILABLE_DOCUMENTOS } from "common/utils/documentos"
import {
  getConceptoCondition,
  handleJoinDuplicates,
  handleUpdateConceptShape,
} from "features/Crear/components/ConceptosTable/utils"
import { newDocumentoSettingsSelector } from "./newDocumentoSettingsSelectors"

export const newDocumentoSelector = (state: $TSMigrationFixMe) =>
  state.newDocumento
export const documentSelector = (state: $TSMigrationFixMe) => state.documentos
export const taxesDefaultSaved = (state: $TSMigrationFixMe) =>
  state.global.tiposImpuestosGenerales

export const getLibradoEmailsOptions = createDraftSafeSelector(
  newDocumentoSelector,
  ({ librado }) =>
    librado?.emails?.map((email: $TSMigrationFixMe) => ({
      label: email.contacto,
      value: email.contacto,
    }))
)

export const getLibradorEmailsOptions = createDraftSafeSelector(
  newDocumentoSelector,
  ({ librador }) =>
    librador?.emails?.map((email: $TSMigrationFixMe) => ({
      label: email.contacto,
      value: email.contacto,
    }))
)

export const getDocumentoSelector = createDraftSafeSelector(
  newDocumentoSelector,
  newDocumentoSettingsSelector,
  (state: $TSMigrationFixMe) => state.newDocumentoSettings,
  (documento: $TSMigrationFixMe, settings: $TSMigrationFixMe) => {
    return {
      fechaOperacion: settings.showFechaOperacion
        ? documento.fechaOperacion
        : null,
      documentosAsociadosId: documento.documentosAsociadosId,
      observaciones: settings.showObservaciones
        ? documento.observaciones
        : null,
      formaPago: settings.showFormaPago ? documento.formaPago : null,
      diasPago: settings.showDiasPago ? documento.diasPago : null,
      descuento: settings.showDescuento ? documento.descuento : null,
      retencionTipoId: settings.showRetencion
        ? documento.retencionTipoId
        : null,
      retencionPorcentaje: settings.showRetencion
        ? documento.retencionPorcentaje
        : null,
      logo: settings.showLogo ? documento.logo : null,
      numero: documento.numero,
      serie: documento.serie,
      fechaEmision: documento.fechaEmision,
      fechaVencimiento: documento.fechaVencimiento,
      librado: documento.librado,
      librador: documento.librador,
      conceptos: documento.conceptos,
      subtotal: documento.subtotal,
      total: documento.total,
      comesFromMdf: documento.comesFromMdf,
      colorSelected: settings.colorSelected,
      archivosAdjuntos: settings.archivosAdjuntos,
      poblacionExtranjera: documento.poblacionExtranjera,
      intervalo: documento.intervalo,
      fechaFin: documento.fechaFin,
      fechaInicio: documento.fechaInicio,
    }
  }
)

export const getConceptosIDSelector = createDraftSafeSelector(
  newDocumentoSelector,
  ({ conceptos }) => {
    return conceptos.reduce(
      (ids: $TSMigrationFixMe, concepto: $TSMigrationFixMe) => {
        return { ...ids, [concepto.id]: concepto }
      },
      {}
    )
  }
)

export const hideAsociarBtnSelector = createDraftSafeSelector(
  newDocumentoSelector,
  ({ tipoDocumento }) => !GET_AVAILABLE_DOCUMENTOS[tipoDocumento]?.length
)

export const canAsociarDocumentosSelector = createDraftSafeSelector(
  newDocumentoSelector,
  ({ librado, librador }) => Boolean(librado?.id && librador?.id)
)

export const getJoinedConceptos = createDraftSafeSelector(
  newDocumentoSelector,
  ({ conceptos }) => {
    return handleJoinDuplicates(
      conceptos,
      getConceptoCondition,
      handleUpdateConceptShape,
      // @ts-expect-error TS(2554): Expected 3 arguments, but got 4.
      true
    )
  }
)

export const getFacturaRecurrenteSelector = createDraftSafeSelector(
  newDocumentoSelector,
  newDocumentoSettingsSelector,
  (state: $TSMigrationFixMe) => state.newDocumentoSettings,
  (documento: $TSMigrationFixMe, settings: $TSMigrationFixMe) => {
    const isValidFinalDate =
      !documento.fechaFin || documento.fechaFin instanceof Date

    return {
      fechaOperacion: settings.showFechaOperacion
        ? documento.fechaOperacion
        : null,
      documentosAsociadosId: documento.documentosAsociadosId,
      observaciones: settings.showObservaciones
        ? documento.observaciones
        : null,
      formaPago: settings.showFormaPago ? documento.formaPago : null,
      diasPago: settings.showDiasPago ? documento.diasPago : null,
      descuento: settings.showDescuento ? documento.descuento : null,
      retencionTipoId: settings.showRetencion
        ? documento.retencionTipoId
        : null,
      retencionPorcentaje: settings.showRetencion
        ? documento.retencionPorcentaje
        : null,
      logo: settings.showLogo ? documento.logo : null,
      numero: documento.numero,
      serie: documento.serie,
      fechaEmision: documento.fechaEmision,
      fechaVencimiento: documento.fechaVencimiento,
      librado: documento.librado,
      librador: documento.librador,
      conceptos: documento.conceptos,
      subtotal: documento.subtotal,
      total: documento.total,
      comesFromMdf: documento.comesFromMdf,
      colorSelected: settings.colorSelected,
      archivosAdjuntos: settings.archivosAdjuntos,
      poblacionExtranjera: documento.poblacionExtranjera,
      intervalo: documento.intervalo,
      fechaFin: !isValidFinalDate ? new Date(documento.fechaFin) : null,
      fechaInicio: new Date(documento.fechaInicio),
      id: documento.id ? documento.id : null,
    }
  }
)
